/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LRouteImport } from './routes/l'
import { Route as ComponentsRouteImport } from './routes/components'
import { Route as SettingsRouteRouteImport } from './routes/settings/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as EngagementsIndexRouteImport } from './routes/engagements/index'
import { Route as ClientsIndexRouteImport } from './routes/clients/index'
import { Route as ViewerSsoRouteImport } from './routes/viewer/sso'
import { Route as ViewerRedeemRouteImport } from './routes/viewer/redeem'
import { Route as SettingsViewersRouteImport } from './routes/settings/viewers'
import { Route as SettingsVendorKnowledgeRouteImport } from './routes/settings/vendor-knowledge'
import { Route as SettingsUsersRouteImport } from './routes/settings/users'
import { Route as SettingsRequirementLibraryRouteImport } from './routes/settings/requirement-library'
import { Route as SettingsQueueRouteImport } from './routes/settings/queue'
import { Route as SettingsNotificationsRouteImport } from './routes/settings/notifications'
import { Route as SettingsMyNotificationsRouteImport } from './routes/settings/my-notifications'
import { Route as SettingsLibraryRouteImport } from './routes/settings/library'
import { Route as SettingsDiscoveryFrameworksRouteImport } from './routes/settings/discovery-frameworks'
import { Route as SettingsDeletedEngagementsRouteImport } from './routes/settings/deleted-engagements'
import { Route as SettingsBrandRouteImport } from './routes/settings/brand'
import { Route as SettingsAssessmentDefaultsRouteImport } from './routes/settings/assessment-defaults'
import { Route as SettingsAiReviewRouteImport } from './routes/settings/ai-review'
import { Route as SettingsAiCostsRouteImport } from './routes/settings/ai-costs'
import { Route as EngagementsEngagementIdRouteRouteImport } from './routes/engagements/$engagementId/route'
import { Route as EngagementsEngagementIdIndexRouteImport } from './routes/engagements/$engagementId/index'
import { Route as ClientsClientIdIndexRouteImport } from './routes/clients/$clientId/index'
import { Route as EngagementsEngagementIdSnapshotRouteImport } from './routes/engagements/$engagementId/snapshot'
import { Route as EngagementsEngagementIdSelectionRouteImport } from './routes/engagements/$engagementId/selection'
import { Route as EngagementsEngagementIdRfisRouteImport } from './routes/engagements/$engagementId/rfis'
import { Route as EngagementsEngagementIdRegisterRouteImport } from './routes/engagements/$engagementId/register'
import { Route as EngagementsEngagementIdReadinessRouteImport } from './routes/engagements/$engagementId/readiness'
import { Route as EngagementsEngagementIdProposalsRouteImport } from './routes/engagements/$engagementId/proposals'
import { Route as EngagementsEngagementIdMethodologyRouteImport } from './routes/engagements/$engagementId/methodology'
import { Route as EngagementsEngagementIdIssuesRouteImport } from './routes/engagements/$engagementId/issues'
import { Route as EngagementsEngagementIdHealthReadinessRouteImport } from './routes/engagements/$engagementId/health-readiness'
import { Route as EngagementsEngagementIdDiscoveryRouteImport } from './routes/engagements/$engagementId/discovery'
import { Route as EngagementsEngagementIdChatRouteImport } from './routes/engagements/$engagementId/chat'
import { Route as EngagementsEngagementIdAuditRouteImport } from './routes/engagements/$engagementId/audit'
import { Route as EngagementsEngagementIdArchiveRouteImport } from './routes/engagements/$engagementId/archive'
import { Route as EngagementsEngagementIdHealthIndexRouteImport } from './routes/engagements/$engagementId/health/index'
import { Route as EngagementsEngagementIdHealthReadinessIndexRouteImport } from './routes/engagements/$engagementId/health-readiness/index'
import { Route as EngagementsEngagementIdGoliveIndexRouteImport } from './routes/engagements/$engagementId/golive/index'
import { Route as EngagementsEngagementIdDocumentsIndexRouteImport } from './routes/engagements/$engagementId/documents/index'
import { Route as EngagementsEngagementIdDiscoveryIndexRouteImport } from './routes/engagements/$engagementId/discovery/index'
import { Route as EngagementsEngagementIdContractIndexRouteImport } from './routes/engagements/$engagementId/contract/index'
import { Route as EngagementsEngagementIdHealthSynthesisRouteImport } from './routes/engagements/$engagementId/health/synthesis'
import { Route as EngagementsEngagementIdHealthScheduleRouteImport } from './routes/engagements/$engagementId/health/schedule'
import { Route as EngagementsEngagementIdHealthInterviewsRouteImport } from './routes/engagements/$engagementId/health/interviews'
import { Route as EngagementsEngagementIdHealthFindingsRouteImport } from './routes/engagements/$engagementId/health/findings'
import { Route as EngagementsEngagementIdHealthDomainsRouteImport } from './routes/engagements/$engagementId/health/domains'
import { Route as EngagementsEngagementIdHealthBudgetRouteImport } from './routes/engagements/$engagementId/health/budget'
import { Route as EngagementsEngagementIdHealthReadinessSnapshotsRouteImport } from './routes/engagements/$engagementId/health-readiness/snapshots'
import { Route as EngagementsEngagementIdHealthReadinessReportRouteImport } from './routes/engagements/$engagementId/health-readiness/report'
import { Route as EngagementsEngagementIdHealthReadinessInterviewsRouteImport } from './routes/engagements/$engagementId/health-readiness/interviews'
import { Route as EngagementsEngagementIdHealthReadinessFindingsRouteImport } from './routes/engagements/$engagementId/health-readiness/findings'
import { Route as EngagementsEngagementIdGoliveXrefRouteImport } from './routes/engagements/$engagementId/golive/xref'
import { Route as EngagementsEngagementIdGoliveTrendRouteImport } from './routes/engagements/$engagementId/golive/trend'
import { Route as EngagementsEngagementIdGoliveScorecardRouteImport } from './routes/engagements/$engagementId/golive/scorecard'
import { Route as EngagementsEngagementIdGoliveCriteriaRouteImport } from './routes/engagements/$engagementId/golive/criteria'
import { Route as EngagementsEngagementIdDocumentsReviewRouteImport } from './routes/engagements/$engagementId/documents/review'
import { Route as EngagementsEngagementIdDocumentsDocumentIdRouteImport } from './routes/engagements/$engagementId/documents/$documentId'
import { Route as EngagementsEngagementIdDiscoverySignoffRouteImport } from './routes/engagements/$engagementId/discovery/signoff'
import { Route as EngagementsEngagementIdDiscoverySetupRouteImport } from './routes/engagements/$engagementId/discovery/setup'
import { Route as EngagementsEngagementIdDiscoverySessionsRouteImport } from './routes/engagements/$engagementId/discovery/sessions'
import { Route as EngagementsEngagementIdDiscoveryMapsRouteImport } from './routes/engagements/$engagementId/discovery/maps'
import { Route as EngagementsEngagementIdDiscoveryFindingsRouteImport } from './routes/engagements/$engagementId/discovery/findings'
import { Route as EngagementsEngagementIdContractVendorRouteImport } from './routes/engagements/$engagementId/contract/vendor'
import { Route as EngagementsEngagementIdContractPulseRouteImport } from './routes/engagements/$engagementId/contract/pulse'
import { Route as EngagementsEngagementIdContractIntegrationsRouteImport } from './routes/engagements/$engagementId/contract/integrations'
import { Route as EngagementsEngagementIdContractDeviationsRouteImport } from './routes/engagements/$engagementId/contract/deviations'
import { Route as EngagementsEngagementIdContractDeliverablesRouteImport } from './routes/engagements/$engagementId/contract/deliverables'
import { Route as EngagementsEngagementIdContractCheckpointsRouteImport } from './routes/engagements/$engagementId/contract/checkpoints'
import { Route as EngagementsEngagementIdContractChangesRouteImport } from './routes/engagements/$engagementId/contract/changes'
import { Route as EngagementsEngagementIdContractBaselineRouteImport } from './routes/engagements/$engagementId/contract/baseline'
import { Route as EngagementsEngagementIdSelectionVendorIntelligenceIndexRouteImport } from './routes/engagements/$engagementId/selection_.vendor-intelligence.index'
import { Route as EngagementsEngagementIdHealthReadinessDomainsIndexRouteImport } from './routes/engagements/$engagementId/health-readiness/domains/index'
import { Route as EngagementsEngagementIdHealthReadinessCriteriaIndexRouteImport } from './routes/engagements/$engagementId/health-readiness/criteria/index'
import { Route as EngagementsEngagementIdSelectionVendorIntelligenceStepRouteImport } from './routes/engagements/$engagementId/selection_.vendor-intelligence.$step'
import { Route as EngagementsEngagementIdHealthReadinessDomainsDomainIdRouteImport } from './routes/engagements/$engagementId/health-readiness/domains/$domainId'
import { Route as EngagementsEngagementIdHealthReadinessCriteriaCriterionIdRouteImport } from './routes/engagements/$engagementId/health-readiness/criteria/$criterionId'

const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LRoute = LRouteImport.update({
  id: '/l',
  path: '/l',
  getParentRoute: () => rootRouteImport,
} as any)
const ComponentsRoute = ComponentsRouteImport.update({
  id: '/components',
  path: '/components',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRouteRoute = SettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const EngagementsIndexRoute = EngagementsIndexRouteImport.update({
  id: '/engagements/',
  path: '/engagements/',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsIndexRoute = ClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => rootRouteImport,
} as any)
const ViewerSsoRoute = ViewerSsoRouteImport.update({
  id: '/viewer/sso',
  path: '/viewer/sso',
  getParentRoute: () => rootRouteImport,
} as any)
const ViewerRedeemRoute = ViewerRedeemRouteImport.update({
  id: '/viewer/redeem',
  path: '/viewer/redeem',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsViewersRoute = SettingsViewersRouteImport.update({
  id: '/viewers',
  path: '/viewers',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsVendorKnowledgeRoute = SettingsVendorKnowledgeRouteImport.update({
  id: '/vendor-knowledge',
  path: '/vendor-knowledge',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsUsersRoute = SettingsUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsRequirementLibraryRoute =
  SettingsRequirementLibraryRouteImport.update({
    id: '/requirement-library',
    path: '/requirement-library',
    getParentRoute: () => SettingsRouteRoute,
  } as any)
const SettingsQueueRoute = SettingsQueueRouteImport.update({
  id: '/queue',
  path: '/queue',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsNotificationsRoute = SettingsNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsMyNotificationsRoute = SettingsMyNotificationsRouteImport.update({
  id: '/my-notifications',
  path: '/my-notifications',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsLibraryRoute = SettingsLibraryRouteImport.update({
  id: '/library',
  path: '/library',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsDiscoveryFrameworksRoute =
  SettingsDiscoveryFrameworksRouteImport.update({
    id: '/discovery-frameworks',
    path: '/discovery-frameworks',
    getParentRoute: () => SettingsRouteRoute,
  } as any)
const SettingsDeletedEngagementsRoute =
  SettingsDeletedEngagementsRouteImport.update({
    id: '/deleted-engagements',
    path: '/deleted-engagements',
    getParentRoute: () => SettingsRouteRoute,
  } as any)
const SettingsBrandRoute = SettingsBrandRouteImport.update({
  id: '/brand',
  path: '/brand',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsAssessmentDefaultsRoute =
  SettingsAssessmentDefaultsRouteImport.update({
    id: '/assessment-defaults',
    path: '/assessment-defaults',
    getParentRoute: () => SettingsRouteRoute,
  } as any)
const SettingsAiReviewRoute = SettingsAiReviewRouteImport.update({
  id: '/ai-review',
  path: '/ai-review',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsAiCostsRoute = SettingsAiCostsRouteImport.update({
  id: '/ai-costs',
  path: '/ai-costs',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const EngagementsEngagementIdRouteRoute =
  EngagementsEngagementIdRouteRouteImport.update({
    id: '/engagements/$engagementId',
    path: '/engagements/$engagementId',
    getParentRoute: () => rootRouteImport,
  } as any)
const EngagementsEngagementIdIndexRoute =
  EngagementsEngagementIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const ClientsClientIdIndexRoute = ClientsClientIdIndexRouteImport.update({
  id: '/clients/$clientId/',
  path: '/clients/$clientId/',
  getParentRoute: () => rootRouteImport,
} as any)
const EngagementsEngagementIdSnapshotRoute =
  EngagementsEngagementIdSnapshotRouteImport.update({
    id: '/snapshot',
    path: '/snapshot',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdSelectionRoute =
  EngagementsEngagementIdSelectionRouteImport.update({
    id: '/selection',
    path: '/selection',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdRfisRoute =
  EngagementsEngagementIdRfisRouteImport.update({
    id: '/rfis',
    path: '/rfis',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdRegisterRoute =
  EngagementsEngagementIdRegisterRouteImport.update({
    id: '/register',
    path: '/register',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdReadinessRoute =
  EngagementsEngagementIdReadinessRouteImport.update({
    id: '/readiness',
    path: '/readiness',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdProposalsRoute =
  EngagementsEngagementIdProposalsRouteImport.update({
    id: '/proposals',
    path: '/proposals',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdMethodologyRoute =
  EngagementsEngagementIdMethodologyRouteImport.update({
    id: '/methodology',
    path: '/methodology',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdIssuesRoute =
  EngagementsEngagementIdIssuesRouteImport.update({
    id: '/issues',
    path: '/issues',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdHealthReadinessRoute =
  EngagementsEngagementIdHealthReadinessRouteImport.update({
    id: '/health-readiness',
    path: '/health-readiness',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdDiscoveryRoute =
  EngagementsEngagementIdDiscoveryRouteImport.update({
    id: '/discovery',
    path: '/discovery',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdChatRoute =
  EngagementsEngagementIdChatRouteImport.update({
    id: '/chat',
    path: '/chat',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdAuditRoute =
  EngagementsEngagementIdAuditRouteImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdArchiveRoute =
  EngagementsEngagementIdArchiveRouteImport.update({
    id: '/archive',
    path: '/archive',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdHealthIndexRoute =
  EngagementsEngagementIdHealthIndexRouteImport.update({
    id: '/health/',
    path: '/health/',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdHealthReadinessIndexRoute =
  EngagementsEngagementIdHealthReadinessIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => EngagementsEngagementIdHealthReadinessRoute,
  } as any)
const EngagementsEngagementIdGoliveIndexRoute =
  EngagementsEngagementIdGoliveIndexRouteImport.update({
    id: '/golive/',
    path: '/golive/',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdDocumentsIndexRoute =
  EngagementsEngagementIdDocumentsIndexRouteImport.update({
    id: '/documents/',
    path: '/documents/',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdDiscoveryIndexRoute =
  EngagementsEngagementIdDiscoveryIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => EngagementsEngagementIdDiscoveryRoute,
  } as any)
const EngagementsEngagementIdContractIndexRoute =
  EngagementsEngagementIdContractIndexRouteImport.update({
    id: '/contract/',
    path: '/contract/',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdHealthSynthesisRoute =
  EngagementsEngagementIdHealthSynthesisRouteImport.update({
    id: '/health/synthesis',
    path: '/health/synthesis',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdHealthScheduleRoute =
  EngagementsEngagementIdHealthScheduleRouteImport.update({
    id: '/health/schedule',
    path: '/health/schedule',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdHealthInterviewsRoute =
  EngagementsEngagementIdHealthInterviewsRouteImport.update({
    id: '/health/interviews',
    path: '/health/interviews',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdHealthFindingsRoute =
  EngagementsEngagementIdHealthFindingsRouteImport.update({
    id: '/health/findings',
    path: '/health/findings',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdHealthDomainsRoute =
  EngagementsEngagementIdHealthDomainsRouteImport.update({
    id: '/health/domains',
    path: '/health/domains',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdHealthBudgetRoute =
  EngagementsEngagementIdHealthBudgetRouteImport.update({
    id: '/health/budget',
    path: '/health/budget',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdHealthReadinessSnapshotsRoute =
  EngagementsEngagementIdHealthReadinessSnapshotsRouteImport.update({
    id: '/snapshots',
    path: '/snapshots',
    getParentRoute: () => EngagementsEngagementIdHealthReadinessRoute,
  } as any)
const EngagementsEngagementIdHealthReadinessReportRoute =
  EngagementsEngagementIdHealthReadinessReportRouteImport.update({
    id: '/report',
    path: '/report',
    getParentRoute: () => EngagementsEngagementIdHealthReadinessRoute,
  } as any)
const EngagementsEngagementIdHealthReadinessInterviewsRoute =
  EngagementsEngagementIdHealthReadinessInterviewsRouteImport.update({
    id: '/interviews',
    path: '/interviews',
    getParentRoute: () => EngagementsEngagementIdHealthReadinessRoute,
  } as any)
const EngagementsEngagementIdHealthReadinessFindingsRoute =
  EngagementsEngagementIdHealthReadinessFindingsRouteImport.update({
    id: '/findings',
    path: '/findings',
    getParentRoute: () => EngagementsEngagementIdHealthReadinessRoute,
  } as any)
const EngagementsEngagementIdGoliveXrefRoute =
  EngagementsEngagementIdGoliveXrefRouteImport.update({
    id: '/golive/xref',
    path: '/golive/xref',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdGoliveTrendRoute =
  EngagementsEngagementIdGoliveTrendRouteImport.update({
    id: '/golive/trend',
    path: '/golive/trend',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdGoliveScorecardRoute =
  EngagementsEngagementIdGoliveScorecardRouteImport.update({
    id: '/golive/scorecard',
    path: '/golive/scorecard',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdGoliveCriteriaRoute =
  EngagementsEngagementIdGoliveCriteriaRouteImport.update({
    id: '/golive/criteria',
    path: '/golive/criteria',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdDocumentsReviewRoute =
  EngagementsEngagementIdDocumentsReviewRouteImport.update({
    id: '/documents/review',
    path: '/documents/review',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdDocumentsDocumentIdRoute =
  EngagementsEngagementIdDocumentsDocumentIdRouteImport.update({
    id: '/documents/$documentId',
    path: '/documents/$documentId',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdDiscoverySignoffRoute =
  EngagementsEngagementIdDiscoverySignoffRouteImport.update({
    id: '/signoff',
    path: '/signoff',
    getParentRoute: () => EngagementsEngagementIdDiscoveryRoute,
  } as any)
const EngagementsEngagementIdDiscoverySetupRoute =
  EngagementsEngagementIdDiscoverySetupRouteImport.update({
    id: '/setup',
    path: '/setup',
    getParentRoute: () => EngagementsEngagementIdDiscoveryRoute,
  } as any)
const EngagementsEngagementIdDiscoverySessionsRoute =
  EngagementsEngagementIdDiscoverySessionsRouteImport.update({
    id: '/sessions',
    path: '/sessions',
    getParentRoute: () => EngagementsEngagementIdDiscoveryRoute,
  } as any)
const EngagementsEngagementIdDiscoveryMapsRoute =
  EngagementsEngagementIdDiscoveryMapsRouteImport.update({
    id: '/maps',
    path: '/maps',
    getParentRoute: () => EngagementsEngagementIdDiscoveryRoute,
  } as any)
const EngagementsEngagementIdDiscoveryFindingsRoute =
  EngagementsEngagementIdDiscoveryFindingsRouteImport.update({
    id: '/findings',
    path: '/findings',
    getParentRoute: () => EngagementsEngagementIdDiscoveryRoute,
  } as any)
const EngagementsEngagementIdContractVendorRoute =
  EngagementsEngagementIdContractVendorRouteImport.update({
    id: '/contract/vendor',
    path: '/contract/vendor',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdContractPulseRoute =
  EngagementsEngagementIdContractPulseRouteImport.update({
    id: '/contract/pulse',
    path: '/contract/pulse',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdContractIntegrationsRoute =
  EngagementsEngagementIdContractIntegrationsRouteImport.update({
    id: '/contract/integrations',
    path: '/contract/integrations',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdContractDeviationsRoute =
  EngagementsEngagementIdContractDeviationsRouteImport.update({
    id: '/contract/deviations',
    path: '/contract/deviations',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdContractDeliverablesRoute =
  EngagementsEngagementIdContractDeliverablesRouteImport.update({
    id: '/contract/deliverables',
    path: '/contract/deliverables',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdContractCheckpointsRoute =
  EngagementsEngagementIdContractCheckpointsRouteImport.update({
    id: '/contract/checkpoints',
    path: '/contract/checkpoints',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdContractChangesRoute =
  EngagementsEngagementIdContractChangesRouteImport.update({
    id: '/contract/changes',
    path: '/contract/changes',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdContractBaselineRoute =
  EngagementsEngagementIdContractBaselineRouteImport.update({
    id: '/contract/baseline',
    path: '/contract/baseline',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdSelectionVendorIntelligenceIndexRoute =
  EngagementsEngagementIdSelectionVendorIntelligenceIndexRouteImport.update({
    id: '/selection_/vendor-intelligence/',
    path: '/selection/vendor-intelligence/',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdHealthReadinessDomainsIndexRoute =
  EngagementsEngagementIdHealthReadinessDomainsIndexRouteImport.update({
    id: '/domains/',
    path: '/domains/',
    getParentRoute: () => EngagementsEngagementIdHealthReadinessRoute,
  } as any)
const EngagementsEngagementIdHealthReadinessCriteriaIndexRoute =
  EngagementsEngagementIdHealthReadinessCriteriaIndexRouteImport.update({
    id: '/criteria/',
    path: '/criteria/',
    getParentRoute: () => EngagementsEngagementIdHealthReadinessRoute,
  } as any)
const EngagementsEngagementIdSelectionVendorIntelligenceStepRoute =
  EngagementsEngagementIdSelectionVendorIntelligenceStepRouteImport.update({
    id: '/selection_/vendor-intelligence/$step',
    path: '/selection/vendor-intelligence/$step',
    getParentRoute: () => EngagementsEngagementIdRouteRoute,
  } as any)
const EngagementsEngagementIdHealthReadinessDomainsDomainIdRoute =
  EngagementsEngagementIdHealthReadinessDomainsDomainIdRouteImport.update({
    id: '/domains/$domainId',
    path: '/domains/$domainId',
    getParentRoute: () => EngagementsEngagementIdHealthReadinessRoute,
  } as any)
const EngagementsEngagementIdHealthReadinessCriteriaCriterionIdRoute =
  EngagementsEngagementIdHealthReadinessCriteriaCriterionIdRouteImport.update({
    id: '/criteria/$criterionId',
    path: '/criteria/$criterionId',
    getParentRoute: () => EngagementsEngagementIdHealthReadinessRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/settings': typeof SettingsRouteRouteWithChildren
  '/components': typeof ComponentsRoute
  '/l': typeof LRoute
  '/login': typeof LoginRoute
  '/notifications': typeof NotificationsRoute
  '/engagements/$engagementId': typeof EngagementsEngagementIdRouteRouteWithChildren
  '/settings/ai-costs': typeof SettingsAiCostsRoute
  '/settings/ai-review': typeof SettingsAiReviewRoute
  '/settings/assessment-defaults': typeof SettingsAssessmentDefaultsRoute
  '/settings/brand': typeof SettingsBrandRoute
  '/settings/deleted-engagements': typeof SettingsDeletedEngagementsRoute
  '/settings/discovery-frameworks': typeof SettingsDiscoveryFrameworksRoute
  '/settings/library': typeof SettingsLibraryRoute
  '/settings/my-notifications': typeof SettingsMyNotificationsRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/queue': typeof SettingsQueueRoute
  '/settings/requirement-library': typeof SettingsRequirementLibraryRoute
  '/settings/users': typeof SettingsUsersRoute
  '/settings/vendor-knowledge': typeof SettingsVendorKnowledgeRoute
  '/settings/viewers': typeof SettingsViewersRoute
  '/viewer/redeem': typeof ViewerRedeemRoute
  '/viewer/sso': typeof ViewerSsoRoute
  '/clients/': typeof ClientsIndexRoute
  '/engagements/': typeof EngagementsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/engagements/$engagementId/archive': typeof EngagementsEngagementIdArchiveRoute
  '/engagements/$engagementId/audit': typeof EngagementsEngagementIdAuditRoute
  '/engagements/$engagementId/chat': typeof EngagementsEngagementIdChatRoute
  '/engagements/$engagementId/discovery': typeof EngagementsEngagementIdDiscoveryRouteWithChildren
  '/engagements/$engagementId/health-readiness': typeof EngagementsEngagementIdHealthReadinessRouteWithChildren
  '/engagements/$engagementId/issues': typeof EngagementsEngagementIdIssuesRoute
  '/engagements/$engagementId/methodology': typeof EngagementsEngagementIdMethodologyRoute
  '/engagements/$engagementId/proposals': typeof EngagementsEngagementIdProposalsRoute
  '/engagements/$engagementId/readiness': typeof EngagementsEngagementIdReadinessRoute
  '/engagements/$engagementId/register': typeof EngagementsEngagementIdRegisterRoute
  '/engagements/$engagementId/rfis': typeof EngagementsEngagementIdRfisRoute
  '/engagements/$engagementId/selection': typeof EngagementsEngagementIdSelectionRoute
  '/engagements/$engagementId/snapshot': typeof EngagementsEngagementIdSnapshotRoute
  '/clients/$clientId/': typeof ClientsClientIdIndexRoute
  '/engagements/$engagementId/': typeof EngagementsEngagementIdIndexRoute
  '/engagements/$engagementId/contract/baseline': typeof EngagementsEngagementIdContractBaselineRoute
  '/engagements/$engagementId/contract/changes': typeof EngagementsEngagementIdContractChangesRoute
  '/engagements/$engagementId/contract/checkpoints': typeof EngagementsEngagementIdContractCheckpointsRoute
  '/engagements/$engagementId/contract/deliverables': typeof EngagementsEngagementIdContractDeliverablesRoute
  '/engagements/$engagementId/contract/deviations': typeof EngagementsEngagementIdContractDeviationsRoute
  '/engagements/$engagementId/contract/integrations': typeof EngagementsEngagementIdContractIntegrationsRoute
  '/engagements/$engagementId/contract/pulse': typeof EngagementsEngagementIdContractPulseRoute
  '/engagements/$engagementId/contract/vendor': typeof EngagementsEngagementIdContractVendorRoute
  '/engagements/$engagementId/discovery/findings': typeof EngagementsEngagementIdDiscoveryFindingsRoute
  '/engagements/$engagementId/discovery/maps': typeof EngagementsEngagementIdDiscoveryMapsRoute
  '/engagements/$engagementId/discovery/sessions': typeof EngagementsEngagementIdDiscoverySessionsRoute
  '/engagements/$engagementId/discovery/setup': typeof EngagementsEngagementIdDiscoverySetupRoute
  '/engagements/$engagementId/discovery/signoff': typeof EngagementsEngagementIdDiscoverySignoffRoute
  '/engagements/$engagementId/documents/$documentId': typeof EngagementsEngagementIdDocumentsDocumentIdRoute
  '/engagements/$engagementId/documents/review': typeof EngagementsEngagementIdDocumentsReviewRoute
  '/engagements/$engagementId/golive/criteria': typeof EngagementsEngagementIdGoliveCriteriaRoute
  '/engagements/$engagementId/golive/scorecard': typeof EngagementsEngagementIdGoliveScorecardRoute
  '/engagements/$engagementId/golive/trend': typeof EngagementsEngagementIdGoliveTrendRoute
  '/engagements/$engagementId/golive/xref': typeof EngagementsEngagementIdGoliveXrefRoute
  '/engagements/$engagementId/health-readiness/findings': typeof EngagementsEngagementIdHealthReadinessFindingsRoute
  '/engagements/$engagementId/health-readiness/interviews': typeof EngagementsEngagementIdHealthReadinessInterviewsRoute
  '/engagements/$engagementId/health-readiness/report': typeof EngagementsEngagementIdHealthReadinessReportRoute
  '/engagements/$engagementId/health-readiness/snapshots': typeof EngagementsEngagementIdHealthReadinessSnapshotsRoute
  '/engagements/$engagementId/health/budget': typeof EngagementsEngagementIdHealthBudgetRoute
  '/engagements/$engagementId/health/domains': typeof EngagementsEngagementIdHealthDomainsRoute
  '/engagements/$engagementId/health/findings': typeof EngagementsEngagementIdHealthFindingsRoute
  '/engagements/$engagementId/health/interviews': typeof EngagementsEngagementIdHealthInterviewsRoute
  '/engagements/$engagementId/health/schedule': typeof EngagementsEngagementIdHealthScheduleRoute
  '/engagements/$engagementId/health/synthesis': typeof EngagementsEngagementIdHealthSynthesisRoute
  '/engagements/$engagementId/contract/': typeof EngagementsEngagementIdContractIndexRoute
  '/engagements/$engagementId/discovery/': typeof EngagementsEngagementIdDiscoveryIndexRoute
  '/engagements/$engagementId/documents/': typeof EngagementsEngagementIdDocumentsIndexRoute
  '/engagements/$engagementId/golive/': typeof EngagementsEngagementIdGoliveIndexRoute
  '/engagements/$engagementId/health-readiness/': typeof EngagementsEngagementIdHealthReadinessIndexRoute
  '/engagements/$engagementId/health/': typeof EngagementsEngagementIdHealthIndexRoute
  '/engagements/$engagementId/health-readiness/criteria/$criterionId': typeof EngagementsEngagementIdHealthReadinessCriteriaCriterionIdRoute
  '/engagements/$engagementId/health-readiness/domains/$domainId': typeof EngagementsEngagementIdHealthReadinessDomainsDomainIdRoute
  '/engagements/$engagementId/selection/vendor-intelligence/$step': typeof EngagementsEngagementIdSelectionVendorIntelligenceStepRoute
  '/engagements/$engagementId/health-readiness/criteria/': typeof EngagementsEngagementIdHealthReadinessCriteriaIndexRoute
  '/engagements/$engagementId/health-readiness/domains/': typeof EngagementsEngagementIdHealthReadinessDomainsIndexRoute
  '/engagements/$engagementId/selection/vendor-intelligence/': typeof EngagementsEngagementIdSelectionVendorIntelligenceIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/components': typeof ComponentsRoute
  '/l': typeof LRoute
  '/login': typeof LoginRoute
  '/notifications': typeof NotificationsRoute
  '/settings/ai-costs': typeof SettingsAiCostsRoute
  '/settings/ai-review': typeof SettingsAiReviewRoute
  '/settings/assessment-defaults': typeof SettingsAssessmentDefaultsRoute
  '/settings/brand': typeof SettingsBrandRoute
  '/settings/deleted-engagements': typeof SettingsDeletedEngagementsRoute
  '/settings/discovery-frameworks': typeof SettingsDiscoveryFrameworksRoute
  '/settings/library': typeof SettingsLibraryRoute
  '/settings/my-notifications': typeof SettingsMyNotificationsRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/queue': typeof SettingsQueueRoute
  '/settings/requirement-library': typeof SettingsRequirementLibraryRoute
  '/settings/users': typeof SettingsUsersRoute
  '/settings/vendor-knowledge': typeof SettingsVendorKnowledgeRoute
  '/settings/viewers': typeof SettingsViewersRoute
  '/viewer/redeem': typeof ViewerRedeemRoute
  '/viewer/sso': typeof ViewerSsoRoute
  '/clients': typeof ClientsIndexRoute
  '/engagements': typeof EngagementsIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/engagements/$engagementId/archive': typeof EngagementsEngagementIdArchiveRoute
  '/engagements/$engagementId/audit': typeof EngagementsEngagementIdAuditRoute
  '/engagements/$engagementId/chat': typeof EngagementsEngagementIdChatRoute
  '/engagements/$engagementId/issues': typeof EngagementsEngagementIdIssuesRoute
  '/engagements/$engagementId/methodology': typeof EngagementsEngagementIdMethodologyRoute
  '/engagements/$engagementId/proposals': typeof EngagementsEngagementIdProposalsRoute
  '/engagements/$engagementId/readiness': typeof EngagementsEngagementIdReadinessRoute
  '/engagements/$engagementId/register': typeof EngagementsEngagementIdRegisterRoute
  '/engagements/$engagementId/rfis': typeof EngagementsEngagementIdRfisRoute
  '/engagements/$engagementId/selection': typeof EngagementsEngagementIdSelectionRoute
  '/engagements/$engagementId/snapshot': typeof EngagementsEngagementIdSnapshotRoute
  '/clients/$clientId': typeof ClientsClientIdIndexRoute
  '/engagements/$engagementId': typeof EngagementsEngagementIdIndexRoute
  '/engagements/$engagementId/contract/baseline': typeof EngagementsEngagementIdContractBaselineRoute
  '/engagements/$engagementId/contract/changes': typeof EngagementsEngagementIdContractChangesRoute
  '/engagements/$engagementId/contract/checkpoints': typeof EngagementsEngagementIdContractCheckpointsRoute
  '/engagements/$engagementId/contract/deliverables': typeof EngagementsEngagementIdContractDeliverablesRoute
  '/engagements/$engagementId/contract/deviations': typeof EngagementsEngagementIdContractDeviationsRoute
  '/engagements/$engagementId/contract/integrations': typeof EngagementsEngagementIdContractIntegrationsRoute
  '/engagements/$engagementId/contract/pulse': typeof EngagementsEngagementIdContractPulseRoute
  '/engagements/$engagementId/contract/vendor': typeof EngagementsEngagementIdContractVendorRoute
  '/engagements/$engagementId/discovery/findings': typeof EngagementsEngagementIdDiscoveryFindingsRoute
  '/engagements/$engagementId/discovery/maps': typeof EngagementsEngagementIdDiscoveryMapsRoute
  '/engagements/$engagementId/discovery/sessions': typeof EngagementsEngagementIdDiscoverySessionsRoute
  '/engagements/$engagementId/discovery/setup': typeof EngagementsEngagementIdDiscoverySetupRoute
  '/engagements/$engagementId/discovery/signoff': typeof EngagementsEngagementIdDiscoverySignoffRoute
  '/engagements/$engagementId/documents/$documentId': typeof EngagementsEngagementIdDocumentsDocumentIdRoute
  '/engagements/$engagementId/documents/review': typeof EngagementsEngagementIdDocumentsReviewRoute
  '/engagements/$engagementId/golive/criteria': typeof EngagementsEngagementIdGoliveCriteriaRoute
  '/engagements/$engagementId/golive/scorecard': typeof EngagementsEngagementIdGoliveScorecardRoute
  '/engagements/$engagementId/golive/trend': typeof EngagementsEngagementIdGoliveTrendRoute
  '/engagements/$engagementId/golive/xref': typeof EngagementsEngagementIdGoliveXrefRoute
  '/engagements/$engagementId/health-readiness/findings': typeof EngagementsEngagementIdHealthReadinessFindingsRoute
  '/engagements/$engagementId/health-readiness/interviews': typeof EngagementsEngagementIdHealthReadinessInterviewsRoute
  '/engagements/$engagementId/health-readiness/report': typeof EngagementsEngagementIdHealthReadinessReportRoute
  '/engagements/$engagementId/health-readiness/snapshots': typeof EngagementsEngagementIdHealthReadinessSnapshotsRoute
  '/engagements/$engagementId/health/budget': typeof EngagementsEngagementIdHealthBudgetRoute
  '/engagements/$engagementId/health/domains': typeof EngagementsEngagementIdHealthDomainsRoute
  '/engagements/$engagementId/health/findings': typeof EngagementsEngagementIdHealthFindingsRoute
  '/engagements/$engagementId/health/interviews': typeof EngagementsEngagementIdHealthInterviewsRoute
  '/engagements/$engagementId/health/schedule': typeof EngagementsEngagementIdHealthScheduleRoute
  '/engagements/$engagementId/health/synthesis': typeof EngagementsEngagementIdHealthSynthesisRoute
  '/engagements/$engagementId/contract': typeof EngagementsEngagementIdContractIndexRoute
  '/engagements/$engagementId/discovery': typeof EngagementsEngagementIdDiscoveryIndexRoute
  '/engagements/$engagementId/documents': typeof EngagementsEngagementIdDocumentsIndexRoute
  '/engagements/$engagementId/golive': typeof EngagementsEngagementIdGoliveIndexRoute
  '/engagements/$engagementId/health-readiness': typeof EngagementsEngagementIdHealthReadinessIndexRoute
  '/engagements/$engagementId/health': typeof EngagementsEngagementIdHealthIndexRoute
  '/engagements/$engagementId/health-readiness/criteria/$criterionId': typeof EngagementsEngagementIdHealthReadinessCriteriaCriterionIdRoute
  '/engagements/$engagementId/health-readiness/domains/$domainId': typeof EngagementsEngagementIdHealthReadinessDomainsDomainIdRoute
  '/engagements/$engagementId/selection/vendor-intelligence/$step': typeof EngagementsEngagementIdSelectionVendorIntelligenceStepRoute
  '/engagements/$engagementId/health-readiness/criteria': typeof EngagementsEngagementIdHealthReadinessCriteriaIndexRoute
  '/engagements/$engagementId/health-readiness/domains': typeof EngagementsEngagementIdHealthReadinessDomainsIndexRoute
  '/engagements/$engagementId/selection/vendor-intelligence': typeof EngagementsEngagementIdSelectionVendorIntelligenceIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/settings': typeof SettingsRouteRouteWithChildren
  '/components': typeof ComponentsRoute
  '/l': typeof LRoute
  '/login': typeof LoginRoute
  '/notifications': typeof NotificationsRoute
  '/engagements/$engagementId': typeof EngagementsEngagementIdRouteRouteWithChildren
  '/settings/ai-costs': typeof SettingsAiCostsRoute
  '/settings/ai-review': typeof SettingsAiReviewRoute
  '/settings/assessment-defaults': typeof SettingsAssessmentDefaultsRoute
  '/settings/brand': typeof SettingsBrandRoute
  '/settings/deleted-engagements': typeof SettingsDeletedEngagementsRoute
  '/settings/discovery-frameworks': typeof SettingsDiscoveryFrameworksRoute
  '/settings/library': typeof SettingsLibraryRoute
  '/settings/my-notifications': typeof SettingsMyNotificationsRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/queue': typeof SettingsQueueRoute
  '/settings/requirement-library': typeof SettingsRequirementLibraryRoute
  '/settings/users': typeof SettingsUsersRoute
  '/settings/vendor-knowledge': typeof SettingsVendorKnowledgeRoute
  '/settings/viewers': typeof SettingsViewersRoute
  '/viewer/redeem': typeof ViewerRedeemRoute
  '/viewer/sso': typeof ViewerSsoRoute
  '/clients/': typeof ClientsIndexRoute
  '/engagements/': typeof EngagementsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/engagements/$engagementId/archive': typeof EngagementsEngagementIdArchiveRoute
  '/engagements/$engagementId/audit': typeof EngagementsEngagementIdAuditRoute
  '/engagements/$engagementId/chat': typeof EngagementsEngagementIdChatRoute
  '/engagements/$engagementId/discovery': typeof EngagementsEngagementIdDiscoveryRouteWithChildren
  '/engagements/$engagementId/health-readiness': typeof EngagementsEngagementIdHealthReadinessRouteWithChildren
  '/engagements/$engagementId/issues': typeof EngagementsEngagementIdIssuesRoute
  '/engagements/$engagementId/methodology': typeof EngagementsEngagementIdMethodologyRoute
  '/engagements/$engagementId/proposals': typeof EngagementsEngagementIdProposalsRoute
  '/engagements/$engagementId/readiness': typeof EngagementsEngagementIdReadinessRoute
  '/engagements/$engagementId/register': typeof EngagementsEngagementIdRegisterRoute
  '/engagements/$engagementId/rfis': typeof EngagementsEngagementIdRfisRoute
  '/engagements/$engagementId/selection': typeof EngagementsEngagementIdSelectionRoute
  '/engagements/$engagementId/snapshot': typeof EngagementsEngagementIdSnapshotRoute
  '/clients/$clientId/': typeof ClientsClientIdIndexRoute
  '/engagements/$engagementId/': typeof EngagementsEngagementIdIndexRoute
  '/engagements/$engagementId/contract/baseline': typeof EngagementsEngagementIdContractBaselineRoute
  '/engagements/$engagementId/contract/changes': typeof EngagementsEngagementIdContractChangesRoute
  '/engagements/$engagementId/contract/checkpoints': typeof EngagementsEngagementIdContractCheckpointsRoute
  '/engagements/$engagementId/contract/deliverables': typeof EngagementsEngagementIdContractDeliverablesRoute
  '/engagements/$engagementId/contract/deviations': typeof EngagementsEngagementIdContractDeviationsRoute
  '/engagements/$engagementId/contract/integrations': typeof EngagementsEngagementIdContractIntegrationsRoute
  '/engagements/$engagementId/contract/pulse': typeof EngagementsEngagementIdContractPulseRoute
  '/engagements/$engagementId/contract/vendor': typeof EngagementsEngagementIdContractVendorRoute
  '/engagements/$engagementId/discovery/findings': typeof EngagementsEngagementIdDiscoveryFindingsRoute
  '/engagements/$engagementId/discovery/maps': typeof EngagementsEngagementIdDiscoveryMapsRoute
  '/engagements/$engagementId/discovery/sessions': typeof EngagementsEngagementIdDiscoverySessionsRoute
  '/engagements/$engagementId/discovery/setup': typeof EngagementsEngagementIdDiscoverySetupRoute
  '/engagements/$engagementId/discovery/signoff': typeof EngagementsEngagementIdDiscoverySignoffRoute
  '/engagements/$engagementId/documents/$documentId': typeof EngagementsEngagementIdDocumentsDocumentIdRoute
  '/engagements/$engagementId/documents/review': typeof EngagementsEngagementIdDocumentsReviewRoute
  '/engagements/$engagementId/golive/criteria': typeof EngagementsEngagementIdGoliveCriteriaRoute
  '/engagements/$engagementId/golive/scorecard': typeof EngagementsEngagementIdGoliveScorecardRoute
  '/engagements/$engagementId/golive/trend': typeof EngagementsEngagementIdGoliveTrendRoute
  '/engagements/$engagementId/golive/xref': typeof EngagementsEngagementIdGoliveXrefRoute
  '/engagements/$engagementId/health-readiness/findings': typeof EngagementsEngagementIdHealthReadinessFindingsRoute
  '/engagements/$engagementId/health-readiness/interviews': typeof EngagementsEngagementIdHealthReadinessInterviewsRoute
  '/engagements/$engagementId/health-readiness/report': typeof EngagementsEngagementIdHealthReadinessReportRoute
  '/engagements/$engagementId/health-readiness/snapshots': typeof EngagementsEngagementIdHealthReadinessSnapshotsRoute
  '/engagements/$engagementId/health/budget': typeof EngagementsEngagementIdHealthBudgetRoute
  '/engagements/$engagementId/health/domains': typeof EngagementsEngagementIdHealthDomainsRoute
  '/engagements/$engagementId/health/findings': typeof EngagementsEngagementIdHealthFindingsRoute
  '/engagements/$engagementId/health/interviews': typeof EngagementsEngagementIdHealthInterviewsRoute
  '/engagements/$engagementId/health/schedule': typeof EngagementsEngagementIdHealthScheduleRoute
  '/engagements/$engagementId/health/synthesis': typeof EngagementsEngagementIdHealthSynthesisRoute
  '/engagements/$engagementId/contract/': typeof EngagementsEngagementIdContractIndexRoute
  '/engagements/$engagementId/discovery/': typeof EngagementsEngagementIdDiscoveryIndexRoute
  '/engagements/$engagementId/documents/': typeof EngagementsEngagementIdDocumentsIndexRoute
  '/engagements/$engagementId/golive/': typeof EngagementsEngagementIdGoliveIndexRoute
  '/engagements/$engagementId/health-readiness/': typeof EngagementsEngagementIdHealthReadinessIndexRoute
  '/engagements/$engagementId/health/': typeof EngagementsEngagementIdHealthIndexRoute
  '/engagements/$engagementId/health-readiness/criteria/$criterionId': typeof EngagementsEngagementIdHealthReadinessCriteriaCriterionIdRoute
  '/engagements/$engagementId/health-readiness/domains/$domainId': typeof EngagementsEngagementIdHealthReadinessDomainsDomainIdRoute
  '/engagements/$engagementId/selection_/vendor-intelligence/$step': typeof EngagementsEngagementIdSelectionVendorIntelligenceStepRoute
  '/engagements/$engagementId/health-readiness/criteria/': typeof EngagementsEngagementIdHealthReadinessCriteriaIndexRoute
  '/engagements/$engagementId/health-readiness/domains/': typeof EngagementsEngagementIdHealthReadinessDomainsIndexRoute
  '/engagements/$engagementId/selection_/vendor-intelligence/': typeof EngagementsEngagementIdSelectionVendorIntelligenceIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/settings'
    | '/components'
    | '/l'
    | '/login'
    | '/notifications'
    | '/engagements/$engagementId'
    | '/settings/ai-costs'
    | '/settings/ai-review'
    | '/settings/assessment-defaults'
    | '/settings/brand'
    | '/settings/deleted-engagements'
    | '/settings/discovery-frameworks'
    | '/settings/library'
    | '/settings/my-notifications'
    | '/settings/notifications'
    | '/settings/queue'
    | '/settings/requirement-library'
    | '/settings/users'
    | '/settings/vendor-knowledge'
    | '/settings/viewers'
    | '/viewer/redeem'
    | '/viewer/sso'
    | '/clients/'
    | '/engagements/'
    | '/settings/'
    | '/engagements/$engagementId/archive'
    | '/engagements/$engagementId/audit'
    | '/engagements/$engagementId/chat'
    | '/engagements/$engagementId/discovery'
    | '/engagements/$engagementId/health-readiness'
    | '/engagements/$engagementId/issues'
    | '/engagements/$engagementId/methodology'
    | '/engagements/$engagementId/proposals'
    | '/engagements/$engagementId/readiness'
    | '/engagements/$engagementId/register'
    | '/engagements/$engagementId/rfis'
    | '/engagements/$engagementId/selection'
    | '/engagements/$engagementId/snapshot'
    | '/clients/$clientId/'
    | '/engagements/$engagementId/'
    | '/engagements/$engagementId/contract/baseline'
    | '/engagements/$engagementId/contract/changes'
    | '/engagements/$engagementId/contract/checkpoints'
    | '/engagements/$engagementId/contract/deliverables'
    | '/engagements/$engagementId/contract/deviations'
    | '/engagements/$engagementId/contract/integrations'
    | '/engagements/$engagementId/contract/pulse'
    | '/engagements/$engagementId/contract/vendor'
    | '/engagements/$engagementId/discovery/findings'
    | '/engagements/$engagementId/discovery/maps'
    | '/engagements/$engagementId/discovery/sessions'
    | '/engagements/$engagementId/discovery/setup'
    | '/engagements/$engagementId/discovery/signoff'
    | '/engagements/$engagementId/documents/$documentId'
    | '/engagements/$engagementId/documents/review'
    | '/engagements/$engagementId/golive/criteria'
    | '/engagements/$engagementId/golive/scorecard'
    | '/engagements/$engagementId/golive/trend'
    | '/engagements/$engagementId/golive/xref'
    | '/engagements/$engagementId/health-readiness/findings'
    | '/engagements/$engagementId/health-readiness/interviews'
    | '/engagements/$engagementId/health-readiness/report'
    | '/engagements/$engagementId/health-readiness/snapshots'
    | '/engagements/$engagementId/health/budget'
    | '/engagements/$engagementId/health/domains'
    | '/engagements/$engagementId/health/findings'
    | '/engagements/$engagementId/health/interviews'
    | '/engagements/$engagementId/health/schedule'
    | '/engagements/$engagementId/health/synthesis'
    | '/engagements/$engagementId/contract/'
    | '/engagements/$engagementId/discovery/'
    | '/engagements/$engagementId/documents/'
    | '/engagements/$engagementId/golive/'
    | '/engagements/$engagementId/health-readiness/'
    | '/engagements/$engagementId/health/'
    | '/engagements/$engagementId/health-readiness/criteria/$criterionId'
    | '/engagements/$engagementId/health-readiness/domains/$domainId'
    | '/engagements/$engagementId/selection/vendor-intelligence/$step'
    | '/engagements/$engagementId/health-readiness/criteria/'
    | '/engagements/$engagementId/health-readiness/domains/'
    | '/engagements/$engagementId/selection/vendor-intelligence/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/components'
    | '/l'
    | '/login'
    | '/notifications'
    | '/settings/ai-costs'
    | '/settings/ai-review'
    | '/settings/assessment-defaults'
    | '/settings/brand'
    | '/settings/deleted-engagements'
    | '/settings/discovery-frameworks'
    | '/settings/library'
    | '/settings/my-notifications'
    | '/settings/notifications'
    | '/settings/queue'
    | '/settings/requirement-library'
    | '/settings/users'
    | '/settings/vendor-knowledge'
    | '/settings/viewers'
    | '/viewer/redeem'
    | '/viewer/sso'
    | '/clients'
    | '/engagements'
    | '/settings'
    | '/engagements/$engagementId/archive'
    | '/engagements/$engagementId/audit'
    | '/engagements/$engagementId/chat'
    | '/engagements/$engagementId/issues'
    | '/engagements/$engagementId/methodology'
    | '/engagements/$engagementId/proposals'
    | '/engagements/$engagementId/readiness'
    | '/engagements/$engagementId/register'
    | '/engagements/$engagementId/rfis'
    | '/engagements/$engagementId/selection'
    | '/engagements/$engagementId/snapshot'
    | '/clients/$clientId'
    | '/engagements/$engagementId'
    | '/engagements/$engagementId/contract/baseline'
    | '/engagements/$engagementId/contract/changes'
    | '/engagements/$engagementId/contract/checkpoints'
    | '/engagements/$engagementId/contract/deliverables'
    | '/engagements/$engagementId/contract/deviations'
    | '/engagements/$engagementId/contract/integrations'
    | '/engagements/$engagementId/contract/pulse'
    | '/engagements/$engagementId/contract/vendor'
    | '/engagements/$engagementId/discovery/findings'
    | '/engagements/$engagementId/discovery/maps'
    | '/engagements/$engagementId/discovery/sessions'
    | '/engagements/$engagementId/discovery/setup'
    | '/engagements/$engagementId/discovery/signoff'
    | '/engagements/$engagementId/documents/$documentId'
    | '/engagements/$engagementId/documents/review'
    | '/engagements/$engagementId/golive/criteria'
    | '/engagements/$engagementId/golive/scorecard'
    | '/engagements/$engagementId/golive/trend'
    | '/engagements/$engagementId/golive/xref'
    | '/engagements/$engagementId/health-readiness/findings'
    | '/engagements/$engagementId/health-readiness/interviews'
    | '/engagements/$engagementId/health-readiness/report'
    | '/engagements/$engagementId/health-readiness/snapshots'
    | '/engagements/$engagementId/health/budget'
    | '/engagements/$engagementId/health/domains'
    | '/engagements/$engagementId/health/findings'
    | '/engagements/$engagementId/health/interviews'
    | '/engagements/$engagementId/health/schedule'
    | '/engagements/$engagementId/health/synthesis'
    | '/engagements/$engagementId/contract'
    | '/engagements/$engagementId/discovery'
    | '/engagements/$engagementId/documents'
    | '/engagements/$engagementId/golive'
    | '/engagements/$engagementId/health-readiness'
    | '/engagements/$engagementId/health'
    | '/engagements/$engagementId/health-readiness/criteria/$criterionId'
    | '/engagements/$engagementId/health-readiness/domains/$domainId'
    | '/engagements/$engagementId/selection/vendor-intelligence/$step'
    | '/engagements/$engagementId/health-readiness/criteria'
    | '/engagements/$engagementId/health-readiness/domains'
    | '/engagements/$engagementId/selection/vendor-intelligence'
  id:
    | '__root__'
    | '/'
    | '/settings'
    | '/components'
    | '/l'
    | '/login'
    | '/notifications'
    | '/engagements/$engagementId'
    | '/settings/ai-costs'
    | '/settings/ai-review'
    | '/settings/assessment-defaults'
    | '/settings/brand'
    | '/settings/deleted-engagements'
    | '/settings/discovery-frameworks'
    | '/settings/library'
    | '/settings/my-notifications'
    | '/settings/notifications'
    | '/settings/queue'
    | '/settings/requirement-library'
    | '/settings/users'
    | '/settings/vendor-knowledge'
    | '/settings/viewers'
    | '/viewer/redeem'
    | '/viewer/sso'
    | '/clients/'
    | '/engagements/'
    | '/settings/'
    | '/engagements/$engagementId/archive'
    | '/engagements/$engagementId/audit'
    | '/engagements/$engagementId/chat'
    | '/engagements/$engagementId/discovery'
    | '/engagements/$engagementId/health-readiness'
    | '/engagements/$engagementId/issues'
    | '/engagements/$engagementId/methodology'
    | '/engagements/$engagementId/proposals'
    | '/engagements/$engagementId/readiness'
    | '/engagements/$engagementId/register'
    | '/engagements/$engagementId/rfis'
    | '/engagements/$engagementId/selection'
    | '/engagements/$engagementId/snapshot'
    | '/clients/$clientId/'
    | '/engagements/$engagementId/'
    | '/engagements/$engagementId/contract/baseline'
    | '/engagements/$engagementId/contract/changes'
    | '/engagements/$engagementId/contract/checkpoints'
    | '/engagements/$engagementId/contract/deliverables'
    | '/engagements/$engagementId/contract/deviations'
    | '/engagements/$engagementId/contract/integrations'
    | '/engagements/$engagementId/contract/pulse'
    | '/engagements/$engagementId/contract/vendor'
    | '/engagements/$engagementId/discovery/findings'
    | '/engagements/$engagementId/discovery/maps'
    | '/engagements/$engagementId/discovery/sessions'
    | '/engagements/$engagementId/discovery/setup'
    | '/engagements/$engagementId/discovery/signoff'
    | '/engagements/$engagementId/documents/$documentId'
    | '/engagements/$engagementId/documents/review'
    | '/engagements/$engagementId/golive/criteria'
    | '/engagements/$engagementId/golive/scorecard'
    | '/engagements/$engagementId/golive/trend'
    | '/engagements/$engagementId/golive/xref'
    | '/engagements/$engagementId/health-readiness/findings'
    | '/engagements/$engagementId/health-readiness/interviews'
    | '/engagements/$engagementId/health-readiness/report'
    | '/engagements/$engagementId/health-readiness/snapshots'
    | '/engagements/$engagementId/health/budget'
    | '/engagements/$engagementId/health/domains'
    | '/engagements/$engagementId/health/findings'
    | '/engagements/$engagementId/health/interviews'
    | '/engagements/$engagementId/health/schedule'
    | '/engagements/$engagementId/health/synthesis'
    | '/engagements/$engagementId/contract/'
    | '/engagements/$engagementId/discovery/'
    | '/engagements/$engagementId/documents/'
    | '/engagements/$engagementId/golive/'
    | '/engagements/$engagementId/health-readiness/'
    | '/engagements/$engagementId/health/'
    | '/engagements/$engagementId/health-readiness/criteria/$criterionId'
    | '/engagements/$engagementId/health-readiness/domains/$domainId'
    | '/engagements/$engagementId/selection_/vendor-intelligence/$step'
    | '/engagements/$engagementId/health-readiness/criteria/'
    | '/engagements/$engagementId/health-readiness/domains/'
    | '/engagements/$engagementId/selection_/vendor-intelligence/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SettingsRouteRoute: typeof SettingsRouteRouteWithChildren
  ComponentsRoute: typeof ComponentsRoute
  LRoute: typeof LRoute
  LoginRoute: typeof LoginRoute
  NotificationsRoute: typeof NotificationsRoute
  EngagementsEngagementIdRouteRoute: typeof EngagementsEngagementIdRouteRouteWithChildren
  ViewerRedeemRoute: typeof ViewerRedeemRoute
  ViewerSsoRoute: typeof ViewerSsoRoute
  ClientsIndexRoute: typeof ClientsIndexRoute
  EngagementsIndexRoute: typeof EngagementsIndexRoute
  ClientsClientIdIndexRoute: typeof ClientsClientIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/l': {
      id: '/l'
      path: '/l'
      fullPath: '/l'
      preLoaderRoute: typeof LRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/components': {
      id: '/components'
      path: '/components'
      fullPath: '/components'
      preLoaderRoute: typeof ComponentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/engagements/': {
      id: '/engagements/'
      path: '/engagements'
      fullPath: '/engagements/'
      preLoaderRoute: typeof EngagementsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/': {
      id: '/clients/'
      path: '/clients'
      fullPath: '/clients/'
      preLoaderRoute: typeof ClientsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/viewer/sso': {
      id: '/viewer/sso'
      path: '/viewer/sso'
      fullPath: '/viewer/sso'
      preLoaderRoute: typeof ViewerSsoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/viewer/redeem': {
      id: '/viewer/redeem'
      path: '/viewer/redeem'
      fullPath: '/viewer/redeem'
      preLoaderRoute: typeof ViewerRedeemRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/viewers': {
      id: '/settings/viewers'
      path: '/viewers'
      fullPath: '/settings/viewers'
      preLoaderRoute: typeof SettingsViewersRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/vendor-knowledge': {
      id: '/settings/vendor-knowledge'
      path: '/vendor-knowledge'
      fullPath: '/settings/vendor-knowledge'
      preLoaderRoute: typeof SettingsVendorKnowledgeRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/users': {
      id: '/settings/users'
      path: '/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof SettingsUsersRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/requirement-library': {
      id: '/settings/requirement-library'
      path: '/requirement-library'
      fullPath: '/settings/requirement-library'
      preLoaderRoute: typeof SettingsRequirementLibraryRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/queue': {
      id: '/settings/queue'
      path: '/queue'
      fullPath: '/settings/queue'
      preLoaderRoute: typeof SettingsQueueRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/notifications': {
      id: '/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof SettingsNotificationsRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/my-notifications': {
      id: '/settings/my-notifications'
      path: '/my-notifications'
      fullPath: '/settings/my-notifications'
      preLoaderRoute: typeof SettingsMyNotificationsRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/library': {
      id: '/settings/library'
      path: '/library'
      fullPath: '/settings/library'
      preLoaderRoute: typeof SettingsLibraryRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/discovery-frameworks': {
      id: '/settings/discovery-frameworks'
      path: '/discovery-frameworks'
      fullPath: '/settings/discovery-frameworks'
      preLoaderRoute: typeof SettingsDiscoveryFrameworksRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/deleted-engagements': {
      id: '/settings/deleted-engagements'
      path: '/deleted-engagements'
      fullPath: '/settings/deleted-engagements'
      preLoaderRoute: typeof SettingsDeletedEngagementsRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/brand': {
      id: '/settings/brand'
      path: '/brand'
      fullPath: '/settings/brand'
      preLoaderRoute: typeof SettingsBrandRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/assessment-defaults': {
      id: '/settings/assessment-defaults'
      path: '/assessment-defaults'
      fullPath: '/settings/assessment-defaults'
      preLoaderRoute: typeof SettingsAssessmentDefaultsRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/ai-review': {
      id: '/settings/ai-review'
      path: '/ai-review'
      fullPath: '/settings/ai-review'
      preLoaderRoute: typeof SettingsAiReviewRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/ai-costs': {
      id: '/settings/ai-costs'
      path: '/ai-costs'
      fullPath: '/settings/ai-costs'
      preLoaderRoute: typeof SettingsAiCostsRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/engagements/$engagementId': {
      id: '/engagements/$engagementId'
      path: '/engagements/$engagementId'
      fullPath: '/engagements/$engagementId'
      preLoaderRoute: typeof EngagementsEngagementIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/engagements/$engagementId/': {
      id: '/engagements/$engagementId/'
      path: '/'
      fullPath: '/engagements/$engagementId/'
      preLoaderRoute: typeof EngagementsEngagementIdIndexRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/clients/$clientId/': {
      id: '/clients/$clientId/'
      path: '/clients/$clientId'
      fullPath: '/clients/$clientId/'
      preLoaderRoute: typeof ClientsClientIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/engagements/$engagementId/snapshot': {
      id: '/engagements/$engagementId/snapshot'
      path: '/snapshot'
      fullPath: '/engagements/$engagementId/snapshot'
      preLoaderRoute: typeof EngagementsEngagementIdSnapshotRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/selection': {
      id: '/engagements/$engagementId/selection'
      path: '/selection'
      fullPath: '/engagements/$engagementId/selection'
      preLoaderRoute: typeof EngagementsEngagementIdSelectionRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/rfis': {
      id: '/engagements/$engagementId/rfis'
      path: '/rfis'
      fullPath: '/engagements/$engagementId/rfis'
      preLoaderRoute: typeof EngagementsEngagementIdRfisRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/register': {
      id: '/engagements/$engagementId/register'
      path: '/register'
      fullPath: '/engagements/$engagementId/register'
      preLoaderRoute: typeof EngagementsEngagementIdRegisterRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/readiness': {
      id: '/engagements/$engagementId/readiness'
      path: '/readiness'
      fullPath: '/engagements/$engagementId/readiness'
      preLoaderRoute: typeof EngagementsEngagementIdReadinessRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/proposals': {
      id: '/engagements/$engagementId/proposals'
      path: '/proposals'
      fullPath: '/engagements/$engagementId/proposals'
      preLoaderRoute: typeof EngagementsEngagementIdProposalsRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/methodology': {
      id: '/engagements/$engagementId/methodology'
      path: '/methodology'
      fullPath: '/engagements/$engagementId/methodology'
      preLoaderRoute: typeof EngagementsEngagementIdMethodologyRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/issues': {
      id: '/engagements/$engagementId/issues'
      path: '/issues'
      fullPath: '/engagements/$engagementId/issues'
      preLoaderRoute: typeof EngagementsEngagementIdIssuesRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/health-readiness': {
      id: '/engagements/$engagementId/health-readiness'
      path: '/health-readiness'
      fullPath: '/engagements/$engagementId/health-readiness'
      preLoaderRoute: typeof EngagementsEngagementIdHealthReadinessRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/discovery': {
      id: '/engagements/$engagementId/discovery'
      path: '/discovery'
      fullPath: '/engagements/$engagementId/discovery'
      preLoaderRoute: typeof EngagementsEngagementIdDiscoveryRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/chat': {
      id: '/engagements/$engagementId/chat'
      path: '/chat'
      fullPath: '/engagements/$engagementId/chat'
      preLoaderRoute: typeof EngagementsEngagementIdChatRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/audit': {
      id: '/engagements/$engagementId/audit'
      path: '/audit'
      fullPath: '/engagements/$engagementId/audit'
      preLoaderRoute: typeof EngagementsEngagementIdAuditRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/archive': {
      id: '/engagements/$engagementId/archive'
      path: '/archive'
      fullPath: '/engagements/$engagementId/archive'
      preLoaderRoute: typeof EngagementsEngagementIdArchiveRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/health/': {
      id: '/engagements/$engagementId/health/'
      path: '/health'
      fullPath: '/engagements/$engagementId/health/'
      preLoaderRoute: typeof EngagementsEngagementIdHealthIndexRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/health-readiness/': {
      id: '/engagements/$engagementId/health-readiness/'
      path: '/'
      fullPath: '/engagements/$engagementId/health-readiness/'
      preLoaderRoute: typeof EngagementsEngagementIdHealthReadinessIndexRouteImport
      parentRoute: typeof EngagementsEngagementIdHealthReadinessRoute
    }
    '/engagements/$engagementId/golive/': {
      id: '/engagements/$engagementId/golive/'
      path: '/golive'
      fullPath: '/engagements/$engagementId/golive/'
      preLoaderRoute: typeof EngagementsEngagementIdGoliveIndexRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/documents/': {
      id: '/engagements/$engagementId/documents/'
      path: '/documents'
      fullPath: '/engagements/$engagementId/documents/'
      preLoaderRoute: typeof EngagementsEngagementIdDocumentsIndexRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/discovery/': {
      id: '/engagements/$engagementId/discovery/'
      path: '/'
      fullPath: '/engagements/$engagementId/discovery/'
      preLoaderRoute: typeof EngagementsEngagementIdDiscoveryIndexRouteImport
      parentRoute: typeof EngagementsEngagementIdDiscoveryRoute
    }
    '/engagements/$engagementId/contract/': {
      id: '/engagements/$engagementId/contract/'
      path: '/contract'
      fullPath: '/engagements/$engagementId/contract/'
      preLoaderRoute: typeof EngagementsEngagementIdContractIndexRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/health/synthesis': {
      id: '/engagements/$engagementId/health/synthesis'
      path: '/health/synthesis'
      fullPath: '/engagements/$engagementId/health/synthesis'
      preLoaderRoute: typeof EngagementsEngagementIdHealthSynthesisRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/health/schedule': {
      id: '/engagements/$engagementId/health/schedule'
      path: '/health/schedule'
      fullPath: '/engagements/$engagementId/health/schedule'
      preLoaderRoute: typeof EngagementsEngagementIdHealthScheduleRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/health/interviews': {
      id: '/engagements/$engagementId/health/interviews'
      path: '/health/interviews'
      fullPath: '/engagements/$engagementId/health/interviews'
      preLoaderRoute: typeof EngagementsEngagementIdHealthInterviewsRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/health/findings': {
      id: '/engagements/$engagementId/health/findings'
      path: '/health/findings'
      fullPath: '/engagements/$engagementId/health/findings'
      preLoaderRoute: typeof EngagementsEngagementIdHealthFindingsRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/health/domains': {
      id: '/engagements/$engagementId/health/domains'
      path: '/health/domains'
      fullPath: '/engagements/$engagementId/health/domains'
      preLoaderRoute: typeof EngagementsEngagementIdHealthDomainsRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/health/budget': {
      id: '/engagements/$engagementId/health/budget'
      path: '/health/budget'
      fullPath: '/engagements/$engagementId/health/budget'
      preLoaderRoute: typeof EngagementsEngagementIdHealthBudgetRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/health-readiness/snapshots': {
      id: '/engagements/$engagementId/health-readiness/snapshots'
      path: '/snapshots'
      fullPath: '/engagements/$engagementId/health-readiness/snapshots'
      preLoaderRoute: typeof EngagementsEngagementIdHealthReadinessSnapshotsRouteImport
      parentRoute: typeof EngagementsEngagementIdHealthReadinessRoute
    }
    '/engagements/$engagementId/health-readiness/report': {
      id: '/engagements/$engagementId/health-readiness/report'
      path: '/report'
      fullPath: '/engagements/$engagementId/health-readiness/report'
      preLoaderRoute: typeof EngagementsEngagementIdHealthReadinessReportRouteImport
      parentRoute: typeof EngagementsEngagementIdHealthReadinessRoute
    }
    '/engagements/$engagementId/health-readiness/interviews': {
      id: '/engagements/$engagementId/health-readiness/interviews'
      path: '/interviews'
      fullPath: '/engagements/$engagementId/health-readiness/interviews'
      preLoaderRoute: typeof EngagementsEngagementIdHealthReadinessInterviewsRouteImport
      parentRoute: typeof EngagementsEngagementIdHealthReadinessRoute
    }
    '/engagements/$engagementId/health-readiness/findings': {
      id: '/engagements/$engagementId/health-readiness/findings'
      path: '/findings'
      fullPath: '/engagements/$engagementId/health-readiness/findings'
      preLoaderRoute: typeof EngagementsEngagementIdHealthReadinessFindingsRouteImport
      parentRoute: typeof EngagementsEngagementIdHealthReadinessRoute
    }
    '/engagements/$engagementId/golive/xref': {
      id: '/engagements/$engagementId/golive/xref'
      path: '/golive/xref'
      fullPath: '/engagements/$engagementId/golive/xref'
      preLoaderRoute: typeof EngagementsEngagementIdGoliveXrefRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/golive/trend': {
      id: '/engagements/$engagementId/golive/trend'
      path: '/golive/trend'
      fullPath: '/engagements/$engagementId/golive/trend'
      preLoaderRoute: typeof EngagementsEngagementIdGoliveTrendRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/golive/scorecard': {
      id: '/engagements/$engagementId/golive/scorecard'
      path: '/golive/scorecard'
      fullPath: '/engagements/$engagementId/golive/scorecard'
      preLoaderRoute: typeof EngagementsEngagementIdGoliveScorecardRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/golive/criteria': {
      id: '/engagements/$engagementId/golive/criteria'
      path: '/golive/criteria'
      fullPath: '/engagements/$engagementId/golive/criteria'
      preLoaderRoute: typeof EngagementsEngagementIdGoliveCriteriaRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/documents/review': {
      id: '/engagements/$engagementId/documents/review'
      path: '/documents/review'
      fullPath: '/engagements/$engagementId/documents/review'
      preLoaderRoute: typeof EngagementsEngagementIdDocumentsReviewRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/documents/$documentId': {
      id: '/engagements/$engagementId/documents/$documentId'
      path: '/documents/$documentId'
      fullPath: '/engagements/$engagementId/documents/$documentId'
      preLoaderRoute: typeof EngagementsEngagementIdDocumentsDocumentIdRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/discovery/signoff': {
      id: '/engagements/$engagementId/discovery/signoff'
      path: '/signoff'
      fullPath: '/engagements/$engagementId/discovery/signoff'
      preLoaderRoute: typeof EngagementsEngagementIdDiscoverySignoffRouteImport
      parentRoute: typeof EngagementsEngagementIdDiscoveryRoute
    }
    '/engagements/$engagementId/discovery/setup': {
      id: '/engagements/$engagementId/discovery/setup'
      path: '/setup'
      fullPath: '/engagements/$engagementId/discovery/setup'
      preLoaderRoute: typeof EngagementsEngagementIdDiscoverySetupRouteImport
      parentRoute: typeof EngagementsEngagementIdDiscoveryRoute
    }
    '/engagements/$engagementId/discovery/sessions': {
      id: '/engagements/$engagementId/discovery/sessions'
      path: '/sessions'
      fullPath: '/engagements/$engagementId/discovery/sessions'
      preLoaderRoute: typeof EngagementsEngagementIdDiscoverySessionsRouteImport
      parentRoute: typeof EngagementsEngagementIdDiscoveryRoute
    }
    '/engagements/$engagementId/discovery/maps': {
      id: '/engagements/$engagementId/discovery/maps'
      path: '/maps'
      fullPath: '/engagements/$engagementId/discovery/maps'
      preLoaderRoute: typeof EngagementsEngagementIdDiscoveryMapsRouteImport
      parentRoute: typeof EngagementsEngagementIdDiscoveryRoute
    }
    '/engagements/$engagementId/discovery/findings': {
      id: '/engagements/$engagementId/discovery/findings'
      path: '/findings'
      fullPath: '/engagements/$engagementId/discovery/findings'
      preLoaderRoute: typeof EngagementsEngagementIdDiscoveryFindingsRouteImport
      parentRoute: typeof EngagementsEngagementIdDiscoveryRoute
    }
    '/engagements/$engagementId/contract/vendor': {
      id: '/engagements/$engagementId/contract/vendor'
      path: '/contract/vendor'
      fullPath: '/engagements/$engagementId/contract/vendor'
      preLoaderRoute: typeof EngagementsEngagementIdContractVendorRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/contract/pulse': {
      id: '/engagements/$engagementId/contract/pulse'
      path: '/contract/pulse'
      fullPath: '/engagements/$engagementId/contract/pulse'
      preLoaderRoute: typeof EngagementsEngagementIdContractPulseRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/contract/integrations': {
      id: '/engagements/$engagementId/contract/integrations'
      path: '/contract/integrations'
      fullPath: '/engagements/$engagementId/contract/integrations'
      preLoaderRoute: typeof EngagementsEngagementIdContractIntegrationsRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/contract/deviations': {
      id: '/engagements/$engagementId/contract/deviations'
      path: '/contract/deviations'
      fullPath: '/engagements/$engagementId/contract/deviations'
      preLoaderRoute: typeof EngagementsEngagementIdContractDeviationsRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/contract/deliverables': {
      id: '/engagements/$engagementId/contract/deliverables'
      path: '/contract/deliverables'
      fullPath: '/engagements/$engagementId/contract/deliverables'
      preLoaderRoute: typeof EngagementsEngagementIdContractDeliverablesRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/contract/checkpoints': {
      id: '/engagements/$engagementId/contract/checkpoints'
      path: '/contract/checkpoints'
      fullPath: '/engagements/$engagementId/contract/checkpoints'
      preLoaderRoute: typeof EngagementsEngagementIdContractCheckpointsRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/contract/changes': {
      id: '/engagements/$engagementId/contract/changes'
      path: '/contract/changes'
      fullPath: '/engagements/$engagementId/contract/changes'
      preLoaderRoute: typeof EngagementsEngagementIdContractChangesRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/contract/baseline': {
      id: '/engagements/$engagementId/contract/baseline'
      path: '/contract/baseline'
      fullPath: '/engagements/$engagementId/contract/baseline'
      preLoaderRoute: typeof EngagementsEngagementIdContractBaselineRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/selection_/vendor-intelligence/': {
      id: '/engagements/$engagementId/selection_/vendor-intelligence/'
      path: '/selection/vendor-intelligence'
      fullPath: '/engagements/$engagementId/selection/vendor-intelligence/'
      preLoaderRoute: typeof EngagementsEngagementIdSelectionVendorIntelligenceIndexRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/health-readiness/domains/': {
      id: '/engagements/$engagementId/health-readiness/domains/'
      path: '/domains'
      fullPath: '/engagements/$engagementId/health-readiness/domains/'
      preLoaderRoute: typeof EngagementsEngagementIdHealthReadinessDomainsIndexRouteImport
      parentRoute: typeof EngagementsEngagementIdHealthReadinessRoute
    }
    '/engagements/$engagementId/health-readiness/criteria/': {
      id: '/engagements/$engagementId/health-readiness/criteria/'
      path: '/criteria'
      fullPath: '/engagements/$engagementId/health-readiness/criteria/'
      preLoaderRoute: typeof EngagementsEngagementIdHealthReadinessCriteriaIndexRouteImport
      parentRoute: typeof EngagementsEngagementIdHealthReadinessRoute
    }
    '/engagements/$engagementId/selection_/vendor-intelligence/$step': {
      id: '/engagements/$engagementId/selection_/vendor-intelligence/$step'
      path: '/selection/vendor-intelligence/$step'
      fullPath: '/engagements/$engagementId/selection/vendor-intelligence/$step'
      preLoaderRoute: typeof EngagementsEngagementIdSelectionVendorIntelligenceStepRouteImport
      parentRoute: typeof EngagementsEngagementIdRouteRoute
    }
    '/engagements/$engagementId/health-readiness/domains/$domainId': {
      id: '/engagements/$engagementId/health-readiness/domains/$domainId'
      path: '/domains/$domainId'
      fullPath: '/engagements/$engagementId/health-readiness/domains/$domainId'
      preLoaderRoute: typeof EngagementsEngagementIdHealthReadinessDomainsDomainIdRouteImport
      parentRoute: typeof EngagementsEngagementIdHealthReadinessRoute
    }
    '/engagements/$engagementId/health-readiness/criteria/$criterionId': {
      id: '/engagements/$engagementId/health-readiness/criteria/$criterionId'
      path: '/criteria/$criterionId'
      fullPath: '/engagements/$engagementId/health-readiness/criteria/$criterionId'
      preLoaderRoute: typeof EngagementsEngagementIdHealthReadinessCriteriaCriterionIdRouteImport
      parentRoute: typeof EngagementsEngagementIdHealthReadinessRoute
    }
  }
}

interface SettingsRouteRouteChildren {
  SettingsAiCostsRoute: typeof SettingsAiCostsRoute
  SettingsAiReviewRoute: typeof SettingsAiReviewRoute
  SettingsAssessmentDefaultsRoute: typeof SettingsAssessmentDefaultsRoute
  SettingsBrandRoute: typeof SettingsBrandRoute
  SettingsDeletedEngagementsRoute: typeof SettingsDeletedEngagementsRoute
  SettingsDiscoveryFrameworksRoute: typeof SettingsDiscoveryFrameworksRoute
  SettingsLibraryRoute: typeof SettingsLibraryRoute
  SettingsMyNotificationsRoute: typeof SettingsMyNotificationsRoute
  SettingsNotificationsRoute: typeof SettingsNotificationsRoute
  SettingsQueueRoute: typeof SettingsQueueRoute
  SettingsRequirementLibraryRoute: typeof SettingsRequirementLibraryRoute
  SettingsUsersRoute: typeof SettingsUsersRoute
  SettingsVendorKnowledgeRoute: typeof SettingsVendorKnowledgeRoute
  SettingsViewersRoute: typeof SettingsViewersRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

const SettingsRouteRouteChildren: SettingsRouteRouteChildren = {
  SettingsAiCostsRoute: SettingsAiCostsRoute,
  SettingsAiReviewRoute: SettingsAiReviewRoute,
  SettingsAssessmentDefaultsRoute: SettingsAssessmentDefaultsRoute,
  SettingsBrandRoute: SettingsBrandRoute,
  SettingsDeletedEngagementsRoute: SettingsDeletedEngagementsRoute,
  SettingsDiscoveryFrameworksRoute: SettingsDiscoveryFrameworksRoute,
  SettingsLibraryRoute: SettingsLibraryRoute,
  SettingsMyNotificationsRoute: SettingsMyNotificationsRoute,
  SettingsNotificationsRoute: SettingsNotificationsRoute,
  SettingsQueueRoute: SettingsQueueRoute,
  SettingsRequirementLibraryRoute: SettingsRequirementLibraryRoute,
  SettingsUsersRoute: SettingsUsersRoute,
  SettingsVendorKnowledgeRoute: SettingsVendorKnowledgeRoute,
  SettingsViewersRoute: SettingsViewersRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}

const SettingsRouteRouteWithChildren = SettingsRouteRoute._addFileChildren(
  SettingsRouteRouteChildren,
)

interface EngagementsEngagementIdDiscoveryRouteChildren {
  EngagementsEngagementIdDiscoveryFindingsRoute: typeof EngagementsEngagementIdDiscoveryFindingsRoute
  EngagementsEngagementIdDiscoveryMapsRoute: typeof EngagementsEngagementIdDiscoveryMapsRoute
  EngagementsEngagementIdDiscoverySessionsRoute: typeof EngagementsEngagementIdDiscoverySessionsRoute
  EngagementsEngagementIdDiscoverySetupRoute: typeof EngagementsEngagementIdDiscoverySetupRoute
  EngagementsEngagementIdDiscoverySignoffRoute: typeof EngagementsEngagementIdDiscoverySignoffRoute
  EngagementsEngagementIdDiscoveryIndexRoute: typeof EngagementsEngagementIdDiscoveryIndexRoute
}

const EngagementsEngagementIdDiscoveryRouteChildren: EngagementsEngagementIdDiscoveryRouteChildren =
  {
    EngagementsEngagementIdDiscoveryFindingsRoute:
      EngagementsEngagementIdDiscoveryFindingsRoute,
    EngagementsEngagementIdDiscoveryMapsRoute:
      EngagementsEngagementIdDiscoveryMapsRoute,
    EngagementsEngagementIdDiscoverySessionsRoute:
      EngagementsEngagementIdDiscoverySessionsRoute,
    EngagementsEngagementIdDiscoverySetupRoute:
      EngagementsEngagementIdDiscoverySetupRoute,
    EngagementsEngagementIdDiscoverySignoffRoute:
      EngagementsEngagementIdDiscoverySignoffRoute,
    EngagementsEngagementIdDiscoveryIndexRoute:
      EngagementsEngagementIdDiscoveryIndexRoute,
  }

const EngagementsEngagementIdDiscoveryRouteWithChildren =
  EngagementsEngagementIdDiscoveryRoute._addFileChildren(
    EngagementsEngagementIdDiscoveryRouteChildren,
  )

interface EngagementsEngagementIdHealthReadinessRouteChildren {
  EngagementsEngagementIdHealthReadinessFindingsRoute: typeof EngagementsEngagementIdHealthReadinessFindingsRoute
  EngagementsEngagementIdHealthReadinessInterviewsRoute: typeof EngagementsEngagementIdHealthReadinessInterviewsRoute
  EngagementsEngagementIdHealthReadinessReportRoute: typeof EngagementsEngagementIdHealthReadinessReportRoute
  EngagementsEngagementIdHealthReadinessSnapshotsRoute: typeof EngagementsEngagementIdHealthReadinessSnapshotsRoute
  EngagementsEngagementIdHealthReadinessIndexRoute: typeof EngagementsEngagementIdHealthReadinessIndexRoute
  EngagementsEngagementIdHealthReadinessCriteriaCriterionIdRoute: typeof EngagementsEngagementIdHealthReadinessCriteriaCriterionIdRoute
  EngagementsEngagementIdHealthReadinessDomainsDomainIdRoute: typeof EngagementsEngagementIdHealthReadinessDomainsDomainIdRoute
  EngagementsEngagementIdHealthReadinessCriteriaIndexRoute: typeof EngagementsEngagementIdHealthReadinessCriteriaIndexRoute
  EngagementsEngagementIdHealthReadinessDomainsIndexRoute: typeof EngagementsEngagementIdHealthReadinessDomainsIndexRoute
}

const EngagementsEngagementIdHealthReadinessRouteChildren: EngagementsEngagementIdHealthReadinessRouteChildren =
  {
    EngagementsEngagementIdHealthReadinessFindingsRoute:
      EngagementsEngagementIdHealthReadinessFindingsRoute,
    EngagementsEngagementIdHealthReadinessInterviewsRoute:
      EngagementsEngagementIdHealthReadinessInterviewsRoute,
    EngagementsEngagementIdHealthReadinessReportRoute:
      EngagementsEngagementIdHealthReadinessReportRoute,
    EngagementsEngagementIdHealthReadinessSnapshotsRoute:
      EngagementsEngagementIdHealthReadinessSnapshotsRoute,
    EngagementsEngagementIdHealthReadinessIndexRoute:
      EngagementsEngagementIdHealthReadinessIndexRoute,
    EngagementsEngagementIdHealthReadinessCriteriaCriterionIdRoute:
      EngagementsEngagementIdHealthReadinessCriteriaCriterionIdRoute,
    EngagementsEngagementIdHealthReadinessDomainsDomainIdRoute:
      EngagementsEngagementIdHealthReadinessDomainsDomainIdRoute,
    EngagementsEngagementIdHealthReadinessCriteriaIndexRoute:
      EngagementsEngagementIdHealthReadinessCriteriaIndexRoute,
    EngagementsEngagementIdHealthReadinessDomainsIndexRoute:
      EngagementsEngagementIdHealthReadinessDomainsIndexRoute,
  }

const EngagementsEngagementIdHealthReadinessRouteWithChildren =
  EngagementsEngagementIdHealthReadinessRoute._addFileChildren(
    EngagementsEngagementIdHealthReadinessRouteChildren,
  )

interface EngagementsEngagementIdRouteRouteChildren {
  EngagementsEngagementIdArchiveRoute: typeof EngagementsEngagementIdArchiveRoute
  EngagementsEngagementIdAuditRoute: typeof EngagementsEngagementIdAuditRoute
  EngagementsEngagementIdChatRoute: typeof EngagementsEngagementIdChatRoute
  EngagementsEngagementIdDiscoveryRoute: typeof EngagementsEngagementIdDiscoveryRouteWithChildren
  EngagementsEngagementIdHealthReadinessRoute: typeof EngagementsEngagementIdHealthReadinessRouteWithChildren
  EngagementsEngagementIdIssuesRoute: typeof EngagementsEngagementIdIssuesRoute
  EngagementsEngagementIdMethodologyRoute: typeof EngagementsEngagementIdMethodologyRoute
  EngagementsEngagementIdProposalsRoute: typeof EngagementsEngagementIdProposalsRoute
  EngagementsEngagementIdReadinessRoute: typeof EngagementsEngagementIdReadinessRoute
  EngagementsEngagementIdRegisterRoute: typeof EngagementsEngagementIdRegisterRoute
  EngagementsEngagementIdRfisRoute: typeof EngagementsEngagementIdRfisRoute
  EngagementsEngagementIdSelectionRoute: typeof EngagementsEngagementIdSelectionRoute
  EngagementsEngagementIdSnapshotRoute: typeof EngagementsEngagementIdSnapshotRoute
  EngagementsEngagementIdIndexRoute: typeof EngagementsEngagementIdIndexRoute
  EngagementsEngagementIdContractBaselineRoute: typeof EngagementsEngagementIdContractBaselineRoute
  EngagementsEngagementIdContractChangesRoute: typeof EngagementsEngagementIdContractChangesRoute
  EngagementsEngagementIdContractCheckpointsRoute: typeof EngagementsEngagementIdContractCheckpointsRoute
  EngagementsEngagementIdContractDeliverablesRoute: typeof EngagementsEngagementIdContractDeliverablesRoute
  EngagementsEngagementIdContractDeviationsRoute: typeof EngagementsEngagementIdContractDeviationsRoute
  EngagementsEngagementIdContractIntegrationsRoute: typeof EngagementsEngagementIdContractIntegrationsRoute
  EngagementsEngagementIdContractPulseRoute: typeof EngagementsEngagementIdContractPulseRoute
  EngagementsEngagementIdContractVendorRoute: typeof EngagementsEngagementIdContractVendorRoute
  EngagementsEngagementIdDocumentsDocumentIdRoute: typeof EngagementsEngagementIdDocumentsDocumentIdRoute
  EngagementsEngagementIdDocumentsReviewRoute: typeof EngagementsEngagementIdDocumentsReviewRoute
  EngagementsEngagementIdGoliveCriteriaRoute: typeof EngagementsEngagementIdGoliveCriteriaRoute
  EngagementsEngagementIdGoliveScorecardRoute: typeof EngagementsEngagementIdGoliveScorecardRoute
  EngagementsEngagementIdGoliveTrendRoute: typeof EngagementsEngagementIdGoliveTrendRoute
  EngagementsEngagementIdGoliveXrefRoute: typeof EngagementsEngagementIdGoliveXrefRoute
  EngagementsEngagementIdHealthBudgetRoute: typeof EngagementsEngagementIdHealthBudgetRoute
  EngagementsEngagementIdHealthDomainsRoute: typeof EngagementsEngagementIdHealthDomainsRoute
  EngagementsEngagementIdHealthFindingsRoute: typeof EngagementsEngagementIdHealthFindingsRoute
  EngagementsEngagementIdHealthInterviewsRoute: typeof EngagementsEngagementIdHealthInterviewsRoute
  EngagementsEngagementIdHealthScheduleRoute: typeof EngagementsEngagementIdHealthScheduleRoute
  EngagementsEngagementIdHealthSynthesisRoute: typeof EngagementsEngagementIdHealthSynthesisRoute
  EngagementsEngagementIdContractIndexRoute: typeof EngagementsEngagementIdContractIndexRoute
  EngagementsEngagementIdDocumentsIndexRoute: typeof EngagementsEngagementIdDocumentsIndexRoute
  EngagementsEngagementIdGoliveIndexRoute: typeof EngagementsEngagementIdGoliveIndexRoute
  EngagementsEngagementIdHealthIndexRoute: typeof EngagementsEngagementIdHealthIndexRoute
  EngagementsEngagementIdSelectionVendorIntelligenceStepRoute: typeof EngagementsEngagementIdSelectionVendorIntelligenceStepRoute
  EngagementsEngagementIdSelectionVendorIntelligenceIndexRoute: typeof EngagementsEngagementIdSelectionVendorIntelligenceIndexRoute
}

const EngagementsEngagementIdRouteRouteChildren: EngagementsEngagementIdRouteRouteChildren =
  {
    EngagementsEngagementIdArchiveRoute: EngagementsEngagementIdArchiveRoute,
    EngagementsEngagementIdAuditRoute: EngagementsEngagementIdAuditRoute,
    EngagementsEngagementIdChatRoute: EngagementsEngagementIdChatRoute,
    EngagementsEngagementIdDiscoveryRoute:
      EngagementsEngagementIdDiscoveryRouteWithChildren,
    EngagementsEngagementIdHealthReadinessRoute:
      EngagementsEngagementIdHealthReadinessRouteWithChildren,
    EngagementsEngagementIdIssuesRoute: EngagementsEngagementIdIssuesRoute,
    EngagementsEngagementIdMethodologyRoute:
      EngagementsEngagementIdMethodologyRoute,
    EngagementsEngagementIdProposalsRoute:
      EngagementsEngagementIdProposalsRoute,
    EngagementsEngagementIdReadinessRoute:
      EngagementsEngagementIdReadinessRoute,
    EngagementsEngagementIdRegisterRoute: EngagementsEngagementIdRegisterRoute,
    EngagementsEngagementIdRfisRoute: EngagementsEngagementIdRfisRoute,
    EngagementsEngagementIdSelectionRoute:
      EngagementsEngagementIdSelectionRoute,
    EngagementsEngagementIdSnapshotRoute: EngagementsEngagementIdSnapshotRoute,
    EngagementsEngagementIdIndexRoute: EngagementsEngagementIdIndexRoute,
    EngagementsEngagementIdContractBaselineRoute:
      EngagementsEngagementIdContractBaselineRoute,
    EngagementsEngagementIdContractChangesRoute:
      EngagementsEngagementIdContractChangesRoute,
    EngagementsEngagementIdContractCheckpointsRoute:
      EngagementsEngagementIdContractCheckpointsRoute,
    EngagementsEngagementIdContractDeliverablesRoute:
      EngagementsEngagementIdContractDeliverablesRoute,
    EngagementsEngagementIdContractDeviationsRoute:
      EngagementsEngagementIdContractDeviationsRoute,
    EngagementsEngagementIdContractIntegrationsRoute:
      EngagementsEngagementIdContractIntegrationsRoute,
    EngagementsEngagementIdContractPulseRoute:
      EngagementsEngagementIdContractPulseRoute,
    EngagementsEngagementIdContractVendorRoute:
      EngagementsEngagementIdContractVendorRoute,
    EngagementsEngagementIdDocumentsDocumentIdRoute:
      EngagementsEngagementIdDocumentsDocumentIdRoute,
    EngagementsEngagementIdDocumentsReviewRoute:
      EngagementsEngagementIdDocumentsReviewRoute,
    EngagementsEngagementIdGoliveCriteriaRoute:
      EngagementsEngagementIdGoliveCriteriaRoute,
    EngagementsEngagementIdGoliveScorecardRoute:
      EngagementsEngagementIdGoliveScorecardRoute,
    EngagementsEngagementIdGoliveTrendRoute:
      EngagementsEngagementIdGoliveTrendRoute,
    EngagementsEngagementIdGoliveXrefRoute:
      EngagementsEngagementIdGoliveXrefRoute,
    EngagementsEngagementIdHealthBudgetRoute:
      EngagementsEngagementIdHealthBudgetRoute,
    EngagementsEngagementIdHealthDomainsRoute:
      EngagementsEngagementIdHealthDomainsRoute,
    EngagementsEngagementIdHealthFindingsRoute:
      EngagementsEngagementIdHealthFindingsRoute,
    EngagementsEngagementIdHealthInterviewsRoute:
      EngagementsEngagementIdHealthInterviewsRoute,
    EngagementsEngagementIdHealthScheduleRoute:
      EngagementsEngagementIdHealthScheduleRoute,
    EngagementsEngagementIdHealthSynthesisRoute:
      EngagementsEngagementIdHealthSynthesisRoute,
    EngagementsEngagementIdContractIndexRoute:
      EngagementsEngagementIdContractIndexRoute,
    EngagementsEngagementIdDocumentsIndexRoute:
      EngagementsEngagementIdDocumentsIndexRoute,
    EngagementsEngagementIdGoliveIndexRoute:
      EngagementsEngagementIdGoliveIndexRoute,
    EngagementsEngagementIdHealthIndexRoute:
      EngagementsEngagementIdHealthIndexRoute,
    EngagementsEngagementIdSelectionVendorIntelligenceStepRoute:
      EngagementsEngagementIdSelectionVendorIntelligenceStepRoute,
    EngagementsEngagementIdSelectionVendorIntelligenceIndexRoute:
      EngagementsEngagementIdSelectionVendorIntelligenceIndexRoute,
  }

const EngagementsEngagementIdRouteRouteWithChildren =
  EngagementsEngagementIdRouteRoute._addFileChildren(
    EngagementsEngagementIdRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SettingsRouteRoute: SettingsRouteRouteWithChildren,
  ComponentsRoute: ComponentsRoute,
  LRoute: LRoute,
  LoginRoute: LoginRoute,
  NotificationsRoute: NotificationsRoute,
  EngagementsEngagementIdRouteRoute:
    EngagementsEngagementIdRouteRouteWithChildren,
  ViewerRedeemRoute: ViewerRedeemRoute,
  ViewerSsoRoute: ViewerSsoRoute,
  ClientsIndexRoute: ClientsIndexRoute,
  EngagementsIndexRoute: EngagementsIndexRoute,
  ClientsClientIdIndexRoute: ClientsClientIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
